import { render, staticRenderFns } from "./Inscricoes.vue?vue&type=template&id=72d3eb46&scoped=true"
import script from "./Inscricoes.vue?vue&type=script&lang=js"
export * from "./Inscricoes.vue?vue&type=script&lang=js"
import style0 from "./Inscricoes.vue?vue&type=style&index=0&id=72d3eb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d3eb46",
  null
  
)

export default component.exports